import { Player } from '@lottiefiles/react-lottie-player';
import { InviteLoadingBox } from './invite-listing-tab.styled';
import { LoadingBox } from './search-filter-sort.styled';

export const InviteLoading = () => {
  return (
    <InviteLoadingBox>
      <Player
        autoplay
        loop
        src="/assets/initializing.json"
        style={{ height: '34px', width: '38px' }}
      ></Player>
      <div>Loading invites...</div>
    </InviteLoadingBox>
  );
};

export const Loading = () => {
  return (
    <LoadingBox>
      <Player
        autoplay
        loop
        src="/assets/initializing.json"
        style={{ height: '34px', width: '38px' }}
      ></Player>
    </LoadingBox>
  );
};
